import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

import { ARService } from '../../ar.service';
import { ArCardPaymentComponent } from '../ar-card-payment/ar-card-payment.component';
import { dataARLedger, dataPatient, dataARPayment } from '../../_models/ar.models';

@Component({
  standalone: false,
  selector: 'app-ar-payment-invoice-generator',
  templateUrl: './ar-payment-invoice-generator.component.html',
  styleUrls: ['./ar-payment-invoice-generator.component.css']
})
export class ArPaymentInvoiceGeneratorComponent implements OnInit {

  latestVersionNumber: number = 1;

  hardRefresh: boolean = false;
  published: boolean = false;
  alertPatient: boolean = false;
  LOCID: string;

  isPaid: boolean = true;
  patientMode: boolean = false;

  generatingPdf: boolean = false;

  dataPatient: dataPatient;
  dataPayment: dataARPayment;
  dataLedgerItems: dataARLedger[] = [];

  isLoading: boolean = false;
  paymentId: string;

  enumCoverageCalcTypePercent: string = '00000048-1000-0000-0000-000000000001';
  enumCoverageCalcTypeAmount: string = '00000048-1000-0000-0000-000000000002';

  dataInvoiceItem: any = {
    title: "Invoice",
    titleImage: 'path-to-image',
    patientName: 'Test Patient',
    showPatientName: true,
    billableName: 'Test Patient',
    showBillableName: true,
    payToName: 'Polyviou Dental Corporation',
    payToAddress1: 'PO Box 11299',
    payToAddress2: ' Newport Beach CA 92658',
    billableItems: [
      {
        serviceDate: '11-11-2012',
        serviceName: 'Test Procedure',
        serviceCode: 'D0123',
        servicePrice: '123',
        serviceInsuranceCoverage: '0',
        serviceDiscount: '20', // %,
        serviceEndPrice: '15'
      }
    ],
  };

  // make this form and allow for the customization of each field.
  // allow the user to toggle certain columns
  // allow the user to hide certain fields
  // save this object in the database to show to the patient in the patient portal
  // put in the payment obj

  // find the 'discount' in the dataARTransactionItem of the ledger item

  constructor(
    public dialogRef: MatDialogRef<ArPaymentInvoiceGeneratorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.patientMode = this.data.patientMode;
    this.paymentId = this.data.paymentId;
    this.dataPatient = this.data.dataPatient;
    this.isPaid = this.data.isPaid;
    this.LOCID = this.data.LOCID;

    this.init();
  }

  init() {
    this.isLoading = true;
    this.getPaymentById(this.paymentId)
      .then((result: any[]) => {

        this.dataLedgerItems = result;
        this.dataLedgerItems.forEach(ledgerItem => {
          ledgerItem.dataARPaymentDistrib = ledgerItem.dataARPaymentDistribs[0];
          this.dataPayment = ledgerItem.dataARPaymentDistrib.dataARPayment;

          if (ledgerItem.dataARTransactionItem.Price == null) {
            ledgerItem.dataARTransactionItem.Price = 0;
          }

          if (ledgerItem.dataARTransactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageCalcTypePercent && ledgerItem.dataARTransactionItem.CoveragePCT) {
            ledgerItem.dataARTransactionItem.DATA_COVERAGE = `${ledgerItem.dataARTransactionItem.CoveragePCT}%`;
          }

          if (ledgerItem.dataARTransactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageCalcTypeAmount && ledgerItem.dataARTransactionItem.CoverageAmount) {
            ledgerItem.dataARTransactionItem.DATA_COVERAGE = `$${ledgerItem.dataARTransactionItem.CoverageAmount}`;
          }

          if (ledgerItem.dataARTransactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageCalcTypePercent && ledgerItem.dataARTransactionItem.CoveragePCT) {
            ledgerItem.dataARTransactionItem.DATA_COVERAGE = `${ledgerItem.dataARTransactionItem.CoveragePCT}%`;
          }

          if (ledgerItem.dataARTransactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageCalcTypeAmount && ledgerItem.dataARTransactionItem.CoverageAmount) {
            ledgerItem.dataARTransactionItem.DATA_COVERAGE = `$${ledgerItem.dataARTransactionItem.CoverageAmount}`;
          }

        });

        console.log('LEDGER ITEMS', this.dataLedgerItems);
        console.log('DATA PAYMENT', this.dataPayment);

        this.dataPayment.DATA_DATE = this.convertUTCDateToLocalDateFromString(this.dataPayment.xauditCreatedOn);

        this.initInvoiceObj();

        //this.setupInvoiceObject();
      }, err => {
        console.log('err');
        this.createMessage("Something went wrong", "Error");
        this.isLoading = false;
      });
  }

  async initInvoiceObj() {
    // check if there is already an invoice obj in the payment column.
    // if not, setupInvoiceObject from scratch
    if (this.dataPayment.PaymentInvoiceObject) {

      try {
        this.dataInvoiceItem = JSON.parse(this.dataPayment.PaymentInvoiceObject);

        var invoiceUpdated = this.checkForInvoiceVersionChanges();

        if (this.dataInvoiceItem.invoiceIsPaid === null || typeof this.dataInvoiceItem.invoiceIsPaid == "undefined") {
          this.dataInvoiceItem.invoiceIsPaid = true;
        }

        if (invoiceUpdated) {
          console.log('FOUND UPDATES... saving');
          await this.arService.saveDataPaymentInvoice(this.paymentId, this.dataInvoiceItem).toPromise();
        }        

        this.isPaid = this.dataInvoiceItem.invoiceIsPaid;
        this.checkForPaymentForInvoice(this.paymentId)
          .then((result) => {           
            this.isLoading = false;
          }, err => {
            this.createMessage("Something went wrong", "Error");
            this.isLoading = false;
          });
        
      } catch (err) {
        this.setupInvoiceObject();
      }

    } else {
      this.setupInvoiceObject();
      this.isLoading = false;
    }
  }

  trimName(name: string) {
    if (name && name.length > 20) {
      return name.slice(0, 20);
    }
    return name;
  }

  calculateAdjustedPrice(ledgerItem) {

    console.log('--------------------');
    console.log('ORIGINAL ITEM', ledgerItem);

    var transactionItem = ledgerItem.dataARTransactionItem;
    var originalPrice = transactionItem.Price;

    var discountType = transactionItem.enumFeeDiscountCalcTypeId;
    var discountAmount = 0;

    var insuranceType = transactionItem.enumFeeCoverageCalcTypeId;
    var insuranceAmount = 0;

    if (discountType === this.enumCoverageCalcTypeAmount) {
      discountAmount = transactionItem.DiscountAmount;
      // make the new original amount = original - discount;
    } else {
      discountAmount = (originalPrice * (transactionItem.DiscountPCT / 100));
      // make the new original amount = this amount
    }

    if (insuranceType === this.enumCoverageCalcTypeAmount) {
      insuranceAmount = transactionItem.CoverageAmount;
    } else {
      insuranceAmount = (originalPrice * (transactionItem.CoveragePCT / 100));
    }

    if (typeof discountAmount == 'undefined' || isNaN(discountAmount)) {
      discountAmount = 0;
    } else if (discountType === this.enumCoverageCalcTypeAmount) {
      originalPrice = originalPrice - discountAmount;
    } else {
      originalPrice = discountAmount;
    }

    if (typeof insuranceAmount == 'undefined' || isNaN(insuranceAmount)) {
      insuranceAmount = 0;
    }

    console.log('ORIGINAL PRICE', originalPrice);
    console.log('DISCOUNT AMOUNT', discountAmount);
    console.log('INSURANCE AMOUNT', insuranceAmount);

    // adjusted price = (original price - discount) - insurance
    var adjustedPrice = originalPrice - insuranceAmount;
    return adjustedPrice;
  }

  checkForInvoiceVersionChanges() {

    var flag = false;

    if (!this.dataInvoiceItem.version) {      
      flag = true;
    }

    // now you can check each version as you go and make better versions

    if (flag || this.dataInvoiceItem.version < 1) {
      // we want to be able to update the servicePriceAdj for each item
      this.dataInvoiceItem.billableItems = [];

      this.dataLedgerItems.forEach((ledgerItem, i) => {

        var adjustedPrice = this.calculateAdjustedPrice(ledgerItem);

        var obj: any = {
          id: i,
          showItem: true,
          serviceDate: new Date(),
          serviceName: ledgerItem.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.Description,
          serviceCode: ledgerItem.dataARTransactionItem.Code,
          serviceCharged: ledgerItem.dataARPaymentDistrib.Amount,
          servicePrice: ledgerItem.dataARTransactionItem.Price,
          servicePriceAdj: adjustedPrice, // set this at the time of payment?
          discounts: [

          ],
        };

        obj.discounts.push(
          { showDiscount: true, discountName: 'SMD Discount', discount: ledgerItem.dataARTransactionItem.DATA_COVERAGE, translatedAmount: (obj.servicePrice - obj.servicePriceAdj) }
        );

        obj.discounts.push(
          { showDiscount: true, discountName: 'Insurance Coverage', discount: '0%', translatedAmount: 0 }
        );


        this.dataInvoiceItem.billableItems.push(obj);
      });

    }

    this.dataInvoiceItem.version = this.latestVersionNumber;

    return flag;
  }

  setupInvoiceObject() {

    this.dataInvoiceItem = {};

    this.dataInvoiceItem = {
      version: this.latestVersionNumber,
      title: "Invoice",
      titleImage: 'path-to-image',
      //invoiceId: this.dataPayment.PaymetnID,
      showDiscounts: true,
      showInvoice: false,
      invoiceIsPaid: this.isPaid,
      showImage: true,
      invoiceDate: new Date(),
      patientName: `${this.dataPatient.dataContact.FirstName} ${this.dataPatient.dataContact.LastName}`,
      showPatientName: true,
      billableName: `${this.dataPatient.dataContact.FirstName} ${this.dataPatient.dataContact.LastName}`,
      showBillableName: true,
      payToName: 'Polyviou Dental Corporation',
      payToAddress1: 'PO Box 11299',
      payToAddress2: ' Newport Beach CA 92658',
      paymentAmount: this.dataPayment.PaymentAmount,
      columns: [
        { title: 'Service Date', key: 'serviceDate', show: true, pipe: 'date' },
        { title: 'Service', key: 'serviceName', show: true, pipe: 'trim' },
        { title: 'Code', key: 'serviceCode', show: true, pipe: 'none' },
        { title: 'Rate', key: 'servicePrice', show: true, pipe: 'currency' },
        { title: 'Adj. Rate', key: 'servicePriceAdj', show: true, pipe: 'currency' },
        { title: 'Charged', key: 'serviceCharged', show: true, pipe: 'currency' },
      ],
      billableItems: [],
      totalDue: 0,
    };


    // you must come up with a new adjusted price

    this.dataLedgerItems.forEach((ledgerItem, i) => {

      var adjustedPrice = this.calculateAdjustedPrice(ledgerItem);

      var obj: any = {
        id: i,
        showItem: true,
        serviceDate: new Date(),
        serviceName: ledgerItem.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.Description,
        serviceCode: ledgerItem.dataARTransactionItem.Code,
        serviceCharged: ledgerItem.dataARPaymentDistrib.Amount,
        servicePrice: ledgerItem.dataARTransactionItem.Price,
        servicePriceAdj: adjustedPrice, // set this at the time of payment?
        discounts: [

        ],
      };
      //this.dataInvoiceItem.totalDue += ledgerItem.dataARTransactionItem.PriceAdjusted;

      obj.discounts.push(
        { showDiscount: true, discountName: 'SMD Discount', discount: ledgerItem.dataARTransactionItem.DATA_COVERAGE, translatedAmount: (obj.servicePrice - obj.servicePriceAdj)  }
      );

      obj.discounts.push(
        { showDiscount: true, discountName: 'Insurance Coverage', discount: '0%', translatedAmount: 0 }
      );


      this.dataInvoiceItem.billableItems.push(obj);
    });

    this.calcInvoiceTotals();
  }  

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }

    let date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  calcInvoiceTotals() {

    this.dataInvoiceItem.totalDue = 0;

    console.log(this.dataInvoiceItem.billableItems);

    this.dataInvoiceItem.billableItems.forEach(item => {
      if (item.showItem) {
        console.log('THIS IS TRUE');
        this.dataInvoiceItem.totalDue += item.servicePriceAdj;
      }
    });
  }

  sendAlertToPatient() {
    this.isLoading = true;
    this.arService.sendAlertToPatientForInvoice(this.dataPatient.PatientId)
      .subscribe(response => {
        this.isLoading = false;
        this.createMessage("Patient notified", "Success");
      }, err => {
        this.createMessage("Something went wrong", "Error");
        this.isLoading = false;
      });
  }

  saveInvoice() {
    this.isLoading = true;
    this.dataInvoiceItem.showInvoice = true;
    this.arService.saveDataPaymentInvoice(this.paymentId, this.dataInvoiceItem)
      .subscribe(response => {
        this.isLoading = false;
        if (this.alertPatient) {
          this.sendAlertToPatient();
        }
        this.close(true);
        this.createMessage("Invoice saved", "Success");
      }, err => {
        this.createMessage("Something went wrong", "Error");
        this.isLoading = false;
      });
  }

  getPaymentById(paymentId: string) {
    let promise = new Promise((resolve, reject) => {
      this.arService.getPaymentById(paymentId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: "top"
    });
  }

  generatePDF() {

    this.generatingPdf = true;

    setTimeout(_ => {
      html2canvas(document.querySelector("#invoice-print-container")).then(canvas => {
        var pdf = new jspdf('p', 'pt', [canvas.width, canvas.height]);
        var imgData = canvas.toDataURL("image/jpeg", 1.0);

        console.log('CANVAS', canvas);

        var logoData = 'https://tdoxfilestore.blob.core.windows.net/testing/practice-logo2.png';

        pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);


        //pdf.addImage(logoData, 200, 0, 180, 90);

        pdf.save(`invoice.pdf`);
        this.generatingPdf = false;
      });
    }, 2000);
  }

  close(payload = false) {

    if (this.hardRefresh) {
      payload = true;
    }

    this.dialogRef.close(payload);
  }

  checkForPaymentCompletedByWP(paymentId) {
    let promise = new Promise((resolve, reject) => {
      this.arService.checkForPaymentCompletedByWP(paymentId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  checkForPaymentForInvoice(paymentId) {
    let promise = new Promise((resolve, reject) => {

      this.checkForPaymentCompletedByWP(this.paymentId)
        .then((paymentIsComplete: boolean) => {

          if (this.isPaid == paymentIsComplete) {
            resolve(true);
          } else if (paymentIsComplete) {
            this.hardRefresh = true;
            this.isPaid = true;
            this.dataInvoiceItem.invoiceIsPaid = true;

            this.arService.saveDataPaymentInvoice(this.paymentId, this.dataInvoiceItem)
              .subscribe(response => {
                resolve(true);
              }, err => {
                reject(err);
              });

          } else {
            this.hardRefresh = true;
            this.isPaid = false;
            resolve(true);
          }

        }, err => {
          reject(err);
        });

    });
    return promise;
  }

  payInvoice() {

    this.isLoading = true;

    this.openCardPaymentComponent()
      .then(result => {

        if (result) {

          this.checkForPaymentForInvoice(this.paymentId)
            .then(finalResult => {
              this.isLoading = false;
              this.createMessage("Invoice updated", "Success");
              this.dialogRef.close(true);
            }, err => {
              this.createMessage("Something went wrong", "Error");
              this.isLoading = false;
            });


          //this.checkForPaymentCompletedByWP(this.paymentId)
          //  .then((paymentIsComplete: boolean) => {

          //    if (paymentIsComplete) {

          //      this.isPaid = true;
          //      this.dataInvoiceItem.invoiceIsPaid = true;
          //      //this.dataInvoiceItem.showInvoice = true;

          //      this.arService.saveDataPaymentInvoice(this.paymentId, this.dataInvoiceItem)
          //        .subscribe(response => {
          //          this.isLoading = false;
          //          this.createMessage("Invoice updated", "Success");
          //          this.dialogRef.close(true);
          //        }, err => {
          //          this.createMessage("Something went wrong", "Error");
          //          this.isLoading = false;
          //        });

          //    } else {
          //      this.createMessage("Something went wrong", "Error");
          //      this.isLoading = false;
          //    }

          //  }, err => {
          //    console.log(err);
          //    this.createMessage("Something went wrong", "Error");
          //    this.isLoading = false;
          //  });




          //this.arService.markPaymentAndDistribsAsNotDeleted(this.paymentId)
          //  .subscribe(response => {
          //    this.isPaid = true;
          //    this.dataInvoiceItem.invoiceIsPaid = true;

          //    this.isLoading = true;
          //    this.dataInvoiceItem.showInvoice = true;
          //    this.arService.saveDataPaymentInvoice(this.paymentId, this.dataInvoiceItem)
          //      .subscribe(response => {
          //        this.isLoading = false;
          //        this.createMessage("Invoice updated", "Success");
          //      }, err => {
          //        this.createMessage("Something went wrong", "Error");
          //        this.isLoading = false;
          //      });


          //  });


        } else {
          this.isLoading = false;
        }

      
      }, err => {
        console.log('ERR', err);
        this.createMessage("Something went wrong", "Error");
        this.isLoading = false;
      });

  }

  openCardPaymentComponent() {
    let promise = new Promise((resolve, reject) => {

      const dialogRef = this.dialog.open(ArCardPaymentComponent, {
        width: '90%',
        height: '90%',
        disableClose: true,
        data: {
          paymentAmount: this.dataInvoiceItem.paymentAmount,
          stagingItem: {},
          invoiceId: this.dataPayment.PaymentReferenceObjectiD,
          LOCID: this.LOCID,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      }, err => {
      });

    });
    return promise;
  }

}
